import { FC } from "react";
import clsx from "clsx";
import { PanelProps } from "@/components/panel/types";
import styles from "./styles.scss";
import { Divider } from "@/components/divider";
import { Row, RowSize } from "@/components/row";

export const Panel: FC<PanelProps> = ({
  className,
  panelInnerClassName,
  panelHeaderClassName,
  dividerClassName,
  header,
  children,
}) => (
  <div className={clsx(styles.panelOuter, className)}>
    <div className={clsx(styles.panelInner, panelInnerClassName)}>
      {header && (
        <>
          <div className={clsx(styles.panelHeader, panelHeaderClassName)}>
            {header}
          </div>
          <Row size={RowSize.Medium} className={dividerClassName}>
            <Divider />
          </Row>
        </>
      )}
      {children}
    </div>
  </div>
);
